<template>
  <div class="shadow-card rounded-2xl bg-white p-6 md:p-8">
    <EmptySection v-if="!data.length" :title="__('Add questions')">
      <template #icon>
        <Icon class="text-xl text-zinc-200" name="quiz" is-filled />
      </template>
    </EmptySection>

    <template v-else>
      <div class="space-y-6">
        <div v-for="item in data" :key="item.id" class="shadow-card flex w-full items-start justify-between gap-4 rounded-lg px-5 py-4 text-left">
          <div class="space-y-2">
            <span class="block text-lg font-medium text-zinc-800 hover:cursor-pointer"  @click="handleButtonClick(item.id)">
              {{ item.question }}
            </span>
            <span v-html="item.answer" v-if="item.isOpen" class="visual-editor block leading-normal text-zinc-600 [&_a]:underline [&_a]:text-blue-600 [&_a]:cursor-pointer"></span>
          </div>

          <button type="button" @click="handleButtonClick(item.id)">
            <Icon class="text-xl text-zinc-600" :name="item.isOpen ? 'expand_less' : 'expand_more'"/>
          </button>

        </div>
      </div>
    </template>

  </div>
</template>

<script setup>
  import { ref } from 'vue';
  import { Icon } from '@/components/block/icon';
  import { EmptySection } from '@/pages/components/empty-section';

  const props = defineProps({
    data: {
      type: Array,
      required: true
    }
  });

  const data = ref(
    JSON.parse(JSON.stringify(props.data)).map((item) => ({
      ...item,
      isOpen: false
    }))
  );

  function handleButtonClick(id) {
    data.value = data.value.map((item) => {
      if (item.id === id) {
        return { ...item, isOpen: !item.isOpen };
      }

      return { ...item, isOpen: false };
    });
  }
</script>
